12<template>
    <div class="device-type-manange relative">

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10"><span v-if="!is_mobile">&ensp;&ensp;&ensp;&ensp;</span>姓名：</span>
                <el-input v-model="user_name" style="width: calc(100% - 6em) !important;" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10"><span v-if="!is_mobile">&ensp;&ensp;&ensp;&ensp;</span>状态：</span>
                <el-select
                    clearable
                    class="status" v-model="status" placeholder="请选择状态" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">手机号码：</span>
                <el-input v-model="mobile" style="width: calc(100% - 6em) !important;" placeholder="手机号码模糊搜素"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24" v-if="role_id != 2">
                <span class="fs-14 pd-r-10">所属集团：</span>
                <el-select
                    clearable
                    class="status" v-model="bloc_id" placeholder="请选择所属集团" style="width: 100%;max-width: none !important;">
                    <el-option style="width: 100%;"
                               v-for="item in allBloc"
                               :key="item.id"
                               :label="item.bloc_name"
                               :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24" v-if="role_id != 2">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <div class="docker_buttons">
            <el-button type="primary" @click="exportExcel" style="margin-left: 10px;">导出数据</el-button>
        </div>
        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%" @selection-change="selectUser">
            <el-table-column v-if="role_id == 1 || (role_id == 3 && child_role_id == 0)"
                type="selection"
                width="40">
            </el-table-column>
            <el-table-column width="60" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="200" prop="user_name" label="特属服务对象姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="bloc_name" label="所属集团" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="200" prop="mobile" label="手机号码" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="150" prop="user_assistant_number" label="联系人数量" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="pay_expired_date" label="付费到期时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="300"
                             prop="address"
                             label="操作"
                             align="center"
                             label-class-name="label"
                             v-slot="scope"
            >
                <el-button :id="'hospitalEdit'" @click="goEdit(scope.row)" type="text" size="small" v-if="role_id != 2">
                    编辑
                </el-button>
                <el-button :id="'hospitalEdit'" @click="goDetail(scope.row)" type="text" size="small">
                    查看
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopUser(scope.row,2)" v-if="role_id != 2 && scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopUser(scope.row,1)" v-if="role_id != 2 && scope.row.status_number==2"
                           type="text"
                           size="small" >启用
                </el-button>
                <el-button :id="'hospitalDel'" @click="resetUserPassword(scope.row)" type="text"
                           size="small" v-if="role_id != 2">重置密码
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 25, 50, 100]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
            v-if="is_pagination_show"
        ></el-pagination>
    </div>
</template>
<script>
import {export2Excel} from "@/utils/excel";
import env from "@/api/env";
import {check} from "@/utils/checkData";
import {getUserInfos} from "@/utils/userInfos";
import {authUrlCheck, base64Parser, getBase64Image, isMobile, loadFile} from "@/api/order";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free";

export default {
    data() {
        return {
            role_id: 0,
            child_role_id: 0,
            user_name: '',
            mobile: '',
            bloc_id: '',
            manager_id: '',
            status: '',
            is_expired: '',
            start_expired_date: '',
            end_expired_date: '',
            search_expired_date: [],
            allBloc: [],
            allManager: [],
            page: 1,
            perpage: 10,
            total: 0,
            tableData: [],
            selectUsers: [],// 批量分配服务专员特属服务对象
            allStatus: [
                {
                    id: 1,
                    name: '启用'
                },
                {
                    id: 2,
                    name: '停用'
                }
            ],
            is_submit: false,
            adduserDialog: false,
            allCompany: [],
            allDepartment: [],
            allGroup: [],
            allGroupUser: [],
            is_pagination_show: true,
            button_position: 'absolute',
            is_mobile: false,
        };
    },
    created() {
        if (isMobile()) {
            this.button_position = 'static'
            this.is_mobile = true
        }
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
        }
        if (this.$route.query.bloc_id) {
            this.bloc_id = this.$route.query.bloc_id;
        }
        if (this.$route.params.bloc_id) {
            this.bloc_id = this.$route.params.bloc_id;
        }
        if (this.$route.query.status == 1) {
            this.status = 1
        }
        if (this.$route.query.start_time) {
            this.search_expired_date[0] = this.$route.query.start_time;
            this.start_expired_date = this.$route.query.start_time;
        }
        if (this.$route.query.end_time) {
            this.search_expired_date[1] = this.$route.query.end_time;
            this.end_expired_date = this.$route.query.end_time;
        }

        if (this.$route.params.status == 1) {
            this.status = 1
        }
        if (this.$route.params.start_time) {
            this.search_expired_date[0] = this.$route.params.start_time;
            this.start_expired_date = this.$route.params.start_time;
        }
        if (this.$route.params.end_time) {
            this.search_expired_date[1] = this.$route.params.end_time;
            this.end_expired_date = this.$route.params.end_time;
        }
    },
    mounted() {
        let prev_page = localStorage.getItem('prev_page');
        if (prev_page == 'user_add' || prev_page == 'user_edit' || prev_page == 'user_detail') {
            let page = 0;
            this.user_name = localStorage.getItem('user_list_user_name')
            this.mobile = localStorage.getItem('user_list_mobile')
            this.bloc_id = localStorage.getItem('user_list_bloc_id')
            this.manager_id = localStorage.getItem('user_list_manager_id')
            this.status = parseInt(localStorage.getItem('user_list_status'))||''
            this.is_expired = parseInt(localStorage.getItem('user_list_is_expired'))||''
            this.start_expired_date = localStorage.getItem('user_list_start_expired_date')||''
            this.end_expired_date = localStorage.getItem('user_list_end_expired_date')||''
            if (this.start_expired_date == 'undefined' || this.start_expired_date == 'null') {
                this.start_expired_date = ''
            }
            if (this.end_expired_date == 'undefined' || this.end_expired_date == 'null') {
                this.end_expired_date = ''
            }
            if (this.user_name == 'undefined' || this.user_name == 'null') {
                this.user_name = ''
            }
            if (this.mobile == 'undefined' || this.mobile == 'null') {
                this.mobile = ''
            }
            if (this.bloc_id == 'undefined' || this.bloc_id == 'null') {
                this.bloc_id = ''
            }
            if (this.manager_id == 'undefined' || this.manager_id == 'null') {
                this.manager_id = ''
            }
            if (this.status == 'undefined' || this.status == 'null') {
                this.status = ''
            }
            if (this.is_expired == 'undefined' || this.is_expired == 'null') {
                this.is_expired = ''
            }
            this.search_expired_date = [this.start_expired_date, this.end_expired_date]
            this.page = parseInt(localStorage.getItem('page'))||1
            this.perpage = parseInt(localStorage.getItem('perpage'))||10
            this.is_pagination_show = false
        }
        // 获取特属服务对象列表
        this.getList();
        this.getListParams();

    },
    methods: {
        // 获取所有特属服务对象
        getList() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'listing',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
                params: {
                    user_name: this.user_name,
                    mobile: this.mobile,
                    bloc_id: this.bloc_id,
                    manager_id: this.manager_id,
                    status: this.status,
                    is_expired: this.is_expired,
                    is_pay_expired: '1',
                    start_expired_date: this.start_expired_date,
                    end_expired_date: this.end_expired_date,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 以序号代替ID
                    res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '启用';
                            res.data.data.list[i].status_number = '1';
                            break;
                        case '2':
                            res.data.data.list[i].status = '停用';
                            res.data.data.list[i].status_number = '2';
                            break;
                    }
                    switch (res.data.data.list[i].is_expired) {
                        case '1':
                            res.data.data.list[i].is_expired = '未缴纳';
                            break;
                        case '2':
                            res.data.data.list[i].is_expired = '已缴纳';
                            break;
                    }
                }
                this.tableData = res.data.data.list;
                this.total = res.data.data.page.count;
                this.is_submit = false;

                localStorage.setItem('user_list_user_name', this.user_name)
                localStorage.setItem('user_list_mobile', this.mobile)
                localStorage.setItem('user_list_bloc_id', this.bloc_id)
                localStorage.setItem('user_list_manager_id', this.manager_id)
                localStorage.setItem('user_list_status', this.status)
                localStorage.setItem('user_list_is_expired', this.is_expired)
                localStorage.setItem('user_list_start_expired_date', this.start_expired_date)
                localStorage.setItem('user_list_end_expired_date', this.end_expired_date)
                localStorage.setItem('prev_page', 'user_list')
                localStorage.setItem('page', this.page)
                localStorage.setItem('perpage', this.perpage)
                this.is_pagination_show = true;
            }).catch(err => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        getListParams() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'listingParams',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allBloc = res.data.data.bloc;
                //this.allManager = res.data.data.manager;
            });
        },

        // 改变每页条数
        changeSite(index) {
            this.perpage = index;
            this.getList();
        },

        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },

        // 跳转编辑页
        goEdit(data) {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/user/UserEdit', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({
                name: "userEdit",
                params: {user_id: data.user_id}
            });
            return;
        },

        // 详情
        goDetail(data) {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/user/UserDetail', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({
                name: "userDetail",
                query: {user_id: data.user_id}
            });
            return;
        },

        // 重置按钮
        resetForm() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.user_name = "";
            this.mobile = "";
            this.bloc_id = "";
            this.manager_id = "";
            this.status = "";
            this.is_expired = "";
            this.start_expired_date = "";
            this.end_expired_date = "";
            this.search_expired_date = "";
            this.page = 1;
            this.getList();
        },

        // 搜索
        search() {

            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;

            if (this.search_expired_date) {
                this.start_expired_date = this.search_expired_date[0];
                this.end_expired_date = this.search_expired_date[1];
            }

            this.page = 1;
            this.getList();
        },

        // 跳转添加页
        addUser() {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/user/UserAdd', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({name: "userAdd", params: {}});
            return;
        },

        // 导出数据
        exportExcel() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this;
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'exportExcel',
                params: {
                    user_name: this.user_name,
                    mobile: this.mobile,
                    bloc_id: this.bloc_id,
                    manager_id: this.manager_id,
                    status: this.status,
                    is_expired: this.is_expired,
                    is_pay_expired: '1',
                    start_expired_date: this.start_expired_date,
                    end_expired_date: this.end_expired_date,
                },
            };
            let colums_list = [
                {title: "序号", key: "no"},
                {title: "特属服务对象姓名", key: "user_name"},
                {title: "所属集团", key: "bloc_name"},
                {title: "手机号码", key: "mobile"},
                {title: "联系人", key: "user_assistant_number"},
                {title: "付费到期时间", key: "pay_expired_date"},
                {title: "状态", key: "status"},
            ];
            let export_data = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }

                let res_data = res.data;
                if (parseInt(res_data.code) != 0) {
                    this.$message.error(res_data.msg);
                    this.is_submit = false;
                    return false;
                }

                for (let i = 0; i < res_data.data.length; i++) {
                    res_data.data[i].no = i + 1
                    let status;
                    switch (res_data.data[i].status) {
                        case '1':
                            status = '启用';
                            break;
                        case '2':
                            status = '停用';
                            break;
                    }

                    let item = {
                        no: res_data.data[i].no,
                        user_name: res_data.data[i].user_name,
                        bloc_name: res_data.data[i].bloc_name,
                        mobile: res_data.data[i].mobile,
                        user_assistant_number: res_data.data[i].user_assistant_number,
                        pay_expired_date: res_data.data[i].pay_expired_date,
                        status: status,
                    };
                    export_data.push(item);
                }
                export2Excel(colums_list, export_data, "导出特属服务对象");
                _that.is_submit = false;
            }).catch(err => {
                _that.is_submit = false;
            }).finally(() => {
                _that.is_submit = false;
            });
        },

        // 启停
        startStopUser(data, status) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (status == '1') {
                var message = `确定启用特属服务对象：${data.user_name}？`;
            }
            if (status == '2') {
                var message = `确定停用特属服务对象：${data.user_name}？`;
            }
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'startStopUser',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: data.user_id,
                        status: status
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '修改成功',
                        duration: 1500,
                    });
                    this.is_submit = false;
                    this.getList();
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        // 重置密码
        resetUserPassword(data) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$confirm(`确定重置 "${data.user_name}" 的密码吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let params = {
                            servername: 'Ruyi_AdminCustomerServices',
                            method: 'resetUserPawssword',
                            pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: data.user_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '重置成功',
                        duration: 1500,
                    });
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 获取特属服务对象资料资料
        getExpertInfo() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            let _that = this;
            this.is_submit = true;
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'expertListing',
                params: {
                    user_name: this.user_name,
                    mobile: this.mobile,
                    bloc_id: this.bloc_id,
                    manager_id: this.manager_id,
                    status: this.status,
                    is_expired: this.is_expired,
                    start_expired_date: this.start_expired_date,
                    end_expired_date: this.end_expired_date,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                this.all_expert = res.data.data

                this.importinfo(res.data.data)
                setTimeout(function () {
                    _that.is_submit = false;
                }, 1500)
            }).catch(err => {
                _that.is_submit = false;
            }).finally(() => {
                _that.is_submit = false;
            });
        },
        // 特属服务对象资料导出到word
        async importinfo(data) {
            let newDataArr = [];
            let assistants = [];
            let doctors = [];
            let manager = [];
            let contracts = [];
            let type_name = '';
            let avatar = '';
            let status_name = '';
            let _that = this
            for (let k = 0; k < data.length; k++) {
                assistants = [];
                doctors = [];
                manager = [];
                contracts = [];
                type_name = '';
                avatar = '';
                status_name = '';
                // 联系人
                for (let i = 0; i < data[k].allCustomer.length; i++) {
                    status_name = data[k].allCustomer[i].status == 1 ? '启用' : '停用';
                    assistants.push({
                        name: data[k].allCustomer[i].user_name,
                        mobile: data[k].allCustomer[i].mobile,
                        status: status_name,
                    })
                }
                // 特属专家
                let doctor_name = '';
                for (let i = 0; i < data[k].allDoctor.length; i++) {
                    doctor_name = data[k].allDoctor[i].doctor_name;
                    doctors.push({
                        name: doctor_name,
                        mobile: data[k].allDoctor[i].doctor_mobile || '',
                        hospital: data[k].allDoctor[i].hospital_name || '',
                        department: data[k].allDoctor[i].department_name || '',
                        title: data[k].allDoctor[i].title_name || '',
                        start_date: data[k].allDoctor[i].start_date || '',
                        end_date: data[k].allDoctor[i].expired_date || '',
                    })
                }
                // 健康管理助理
                for (let i = 0; i < data[k].allManager.length; i++) {
                    manager.push({
                        name: data[k].allManager[i].user_name || '',
                        mobile: data[k].allManager[i].mobile || '',
                        company: data[k].allManager[i].company_name || '',
                        department: data[k].allManager[i].department_name || '',
                        group: data[k].allManager[i].group_name || '',
                        doctor_name: data[k].allManager[i].doctor_name || '',
                        doctor_mobile: data[k].allManager[i].doctor_mobile || '',
                        title_name: data[k].allManager[i].title_name || '',
                    })
                }
                // 签约记录
                for (let i = 0; i < data[k].allContract.length; i++) {
                    type_name = data[k].allContract[i].contract_type == 2 ? '续约' : '新约';
                    contracts.push({
                        doctor: data[k].allContract[i].doctor_name,
                        type: type_name,
                        start_date: data[k].allContract[i].start_date || '',
                        end_date: data[k].allContract[i].expired_date || '',
                        create_date: data[k].allContract[i].create_date || '',
                    })
                }

                if (data[k].user.user_avatar) {
                    avatar = await getBase64Image(env.IMG_COMMON_URL_PREFIX + data[k].user.user_avatar)
                }
                status_name = data[k].user.status == 1 ? '启用' : '停用';
                newDataArr.push({
                    "avatar": avatar,
                    "user_name": data[k].user.user_name,
                    "status": status_name,
                    "nick_name": data[k].user.nick_name || '  ',
                    "idcard": data[k].user.idcard,
                    "bloc_name": data[k].user.bloc_name,
                    "mobile": data[k].user.mobile,
                    "position": data[k].user.posistion || '  ',
                    "expired_date": data[k].user.expired_date || ' ',
                    "health_num": data[k].user.health_records_number || '',
                    "doctor_num": data[k].user.client_doctor_number || '',
                    "assistant_name": data[k].user.assistant_name || '',
                    "assistant_mobile": data[k].user.assistant_mobile || '',
                    "client_doctor_num": data[k].user.client_doctor_number || 0,
                    "history_doctor_num": data[k].user.all_log_client_doctor_number || 0,
                    "reservation_num": data[k].user.reservationing_number || 0,
                    "int_num": data[k].user.reservation_interrupt_number || 0,
                    "succ_num": data[k].user.reservationed_number || 0,
                    "assistants": assistants,
                    "manager": manager,
                    "doctor": doctors,
                    "contracts": contracts,
                })
            }

            loadFile(
                "detail-user.docx",
                // "user.docx",
                function (error, content) {

                    if (error) {
                        _that.is_submit = false;
                        throw error;
                    }

                    const zip = new PizZip(content);

                    let imageOpts = {}
                    imageOpts.centered = true;  // 图片居中，在word模板中定义方式为{%%image}
                    imageOpts.fileType = "docx";
                    imageOpts.getImage = function (newImgUrl) {
                        return base64Parser(newImgUrl);
                    }
                    imageOpts.getSize = function () {
                        return [190, 190]
                    }

                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true,
                        modules: [new ImageModule(imageOpts)],
                    });

                    doc.render({
                        "user_info": newDataArr
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, "特属服务对象资料.docx");
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }
            );

        },

        selectUser(data) {
            let len = data.length
            let is_user_set = false;
            let is_id_set = false;
            this.selectUsers = [];
            this.userForm.user_ids = [];
            for (let i = 0; i < len; i++) {
                for (let j = 0; j < this.selectUsers.length; j++) {
                    if (data[i].user_id == this.selectUsers[j].user_id) {
                        is_user_set = true;
                        break;
                    }
                }

                if (!is_user_set) {
                    this.selectUsers.push({
                        user_id: data[i].user_id,
                        user_name: data[i].user_name
                    })
                    this.userForm.user_ids.push(data[i].user_id)
                }
            }
        },
        addOperate() {
            if (this.userForm.user_ids.length < 1) {
                this.$message({
                    type: "warning",
                    message: '请选择需要分配特属服务专员的特属服务对象',
                    duration: 1500,
                });
                return;
            }
            this.createParams()
            this.userForm.company_id = ''
            this.userForm.department_id = ''
            this.userForm.group_id = ''
            this.userForm.operate_user_id = ''
            this.adduserDialog = true;
        },
        async addOperateData(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }

            this.is_submit = true;

            this.$refs[formName].validate(valid => {
                if (valid) {
                    let allUser = this.tableData;
                    let allUserLen = allUser.length;
                    let selectIds = this.userForm.user_ids;
                    let isOperateUser = [];
                    for (let i = 0; i < allUserLen; i++) {
                        for (let j = 0; j < selectIds.length; j++) {

                            if (allUser[i].user_id == selectIds[j] && allUser[i].operate_user_id > 0) {
                                // 修改运营服务专员提示
                                isOperateUser.push(selectIds[j])
                            }
                        }
                    }

                    if (isOperateUser.length > 0) {
                        this.$confirm('部分特属服务对象已有运营服务状态，是否确认修改', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {

                            this.submitFormComit();

                        }).catch(() => {
                            this.adduserDialog = false;
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.submitFormComit();
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },
        async submitFormComit() {
            let params = {
                'servername': 'Ruyi_AdminCustomerServices',
                'method': 'usersAddOperate',
                'params': this.userForm
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                this.$message({
                    type: "success",
                    message: '特属服务专员分配成功',
                    duration: 1500,
                });
                this.is_submit = false;
                this.adduserDialog = false;
                let _that = this;
                setTimeout(function () {
                    _that.selectUsers = [];
                    _that.userForm.user_ids = [];
                    _that.getList();
                }, 500)
            }).finally(()=>{
                this.is_submit = false;
            });
        },
        createParams() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'createEditUserParams',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompany = res.data.data.company;
            });
        },
        changeCompany() {
            this.userForm.department_id = '';
            this.userForm.group_id = '';
            this.userForm.operate_user_id = '';
            this.getAllDeparment();
        },
        changeDeparment() {
            this.userForm.group_id = '';
            this.userForm.operate_user_id = '';
            this.getAllCompanyGroup();
        },
        getAllDeparment() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyDeparment',
                params: {
                    company_id: this.userForm.company_id,
                    status: 1
                }
            };
            this.allDepartment = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allDepartment = res.data.data;
            });
        },
        // 获取组成员
        changeGroup() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllGroupUser',
                params: {
                    company_id: this.userForm.company_id,
                    department_id: this.userForm.department_id,
                    group_id: this.userForm.group_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allGroupUser = res.data.data;
            });
        },
        getAllCompanyGroup() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyGroup',
                params: {
                    company_id: this.userForm.company_id,
                    department_id: this.userForm.department_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allGroup = res.data.data;
            });
        },
        dialogClose() {
            this.selectUsers = [];
            this.userForm.user_ids = [];
        },

    }
};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.docker_buttons {
    float: right;
    margin: 30px 0px 8px 0px;

    .el-button {
        width: auto;
        height: 32px;
        line-height: 7px;
    }
}

.inputs .el-select.status .el-input {
    width: 100%;
}
.el-dialog{
    min-width: 480px !important;
}
.el-col{
    margin-bottom: 10px;
    input{
        width: 100%;
    }
}
.el-table .admin_user_name .cell {
    white-space: pre-wrap;
}
</style>
